import { render } from "./page7.vue?vue&type=template&id=466c8fb7"
import script from "./page7.vue?vue&type=script&lang=js"
export * from "./page7.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__